import React, { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

const MainLayout = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  
  return (
    <Box
      className="main-layout"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      <Box
        component="main"
        className="main-content"
        sx={{
          flex: 1,
          marginLeft: drawerOpen ? "240px" : "60px",
          width: drawerOpen ? "calc(100% - 240px)" : "calc(100% - 60px)",
          transition: "margin-left 0.3s ease, width 0.3s ease",
          "@media (max-width: 768px)": { marginLeft: 0, width: "100%" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default MainLayout;